module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labelI18n.en":"Label(En)","labelI18n.de":"Label(De)","labelSearch":"Search"},"de":{"labelI18n.en":"Label(En)","labelI18n.de":"Label(De)","labelSearch":"Suchen"}}')
  delete Component.options._Ctor
}
